import { Module } from '@nestjs/common';
import { PrismaModule } from '../prisma/prisma.module';
import { ProveedorMarcaController } from './proveedor-marca.controller';
import { ProveedorMarcaService } from './proveedor-marca.service';

@Module({
  imports: [PrismaModule],
  controllers: [ProveedorMarcaController],
  providers: [ProveedorMarcaService],
  exports: [ProveedorMarcaService],
})
export class ProveedorMarcaModule {}
